(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/components/competition-subscriber.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/components/competition-subscriber.js');
"use strict";


const useCompetitionResultSocket = svs.components.marketplaceCompetition.services.hooks.useCompetitionResultSocket;
const CompetitionSubscriber = React.memo(_ref => {
  let competitionId = _ref.competitionId;
  useCompetitionResultSocket(competitionId);
  return null;
});
setGlobal('svs.components.marketplaceCompetition.services.components.CompetitionSubscriber', CompetitionSubscriber);

 })(window);